<template>
  <div class="container">
      <div class="contract">
          <h2 class="text-center magb20">HƯỚNG DẪN SỬ DỤNG </h2>
          <p class="text-center fonsize-20 magb20">MY NEXTPAY APP</p>
          <div class="guide">
              <div id="accordion" class="accordion" v-viewer>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c0">
                              1. Giới thiệu về phần mềm
                          </a>
                      </div>
                      <div id="c0" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <p>My Nextpay là ứng dụng APP hỗ trợ cho nhân viên Sales của Nextpay thực hiện công việc
                                  được thuận tiện hơn, ứng dụng bao gồm các tính năng :
                              </p>
                              <p> - Checkin/ Checkout </p>
                              <p>- Tạo và quản lý lịch làm việc của mình </p>
                              <p> - Quản lý danh sách khách hàng của mình </p>
                              <p> - Theo dõi được tỷ lệ KPI đã hoàn thành </p>

                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c1">
                              2. Cài đặt phần mềm
                          </a>
                      </div>
                      <div id="c1" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <p class="magb20">Truy cập <b>Appstore</b> hoặc <b>Google Play</b> nhập từ khóa “My
                                  Nextpay” để tải
                                  app </p>
                              <p class="text-center">
                                <img  src="@/assets/img/hdsd/Picture1.png">
                              </p>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c2">
                              3. Đăng nhập
                          </a>
                      </div>
                      <div id="c2" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <p class="magb20">Kích chọn mở App => Bạn có muốn nhận thông báo => chọn “Cho phép”</p>
                              <p class="text-center"><img  src="@/assets/img/hdsd/Picture2.png"></p>
                              <p>Thực hiện nhập Email và Password được cung cấp từ quản lý => Kích chọn “<b>Đăng
                                      nhập</b>”
                              </p>
                              <p>=> Cho phép phần mềm sử dụng vị trí của bạn để tiếp tục</p>
                              <p class="text-center"><img  src="@/assets/img/hdsd/Picture3.png"></p>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c3">
                              4. Trang chủ
                          </a>
                      </div>
                      <div id="c3" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <p>User có thể xem được thời gian làm việc, thực hiện Check in/ Check out, tạo và xem
                                  lịch hẹn/công việc trong ngày, xem thông báo trên trang này</p>
                              <p class="text-center"><img  src="@/assets/img/hdsd/Picture4.png"></p>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c4">
                              5. Check In/ Out
                          </a>
                      </div>
                      <div id="c4" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div class="w100">
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture5.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Kích chọn <b>“Check In/ Out”</b> từ trang chủ hoặc từ trang điều hướng
                                      </li>
                                      <li><b>User bắt buộc phải cho phép ứng dụng truy cập vào vị trí mới có thể
                                              chấm
                                              công.</b></li>
                                      <li>Có thể update chấm công nhiều lần. Thời gian hiển thị trên trang chủ sẽ
                                          hiển
                                          thị thời gian check in sớm nhất và thời gian check out muộn nhất</li>
                                  </ul>
                              </div>
                              <p class="magb20"><b>Định nghĩa màu thời gian chấm công trên trang home:</b></p>
                              <div>
                                  1. Thời gian từ đen chuyển thành màu xanh : Đã check in/ check out
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture6.png" class="maxwd65">
                                  </p>
                              </div>
                              <div>
                                  2. Nếu quá giờ chưa check in/ check out, thời gian tương ứng sẽ hiển thị màu đỏ
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture7.png" class="maxwd65">
                                  </p>
                              </div>
                              <div>
                                  3. Nếu chưa đến giờ check in/ check out, thời gian tương ứng sẽ hiển thị màu đen
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture8.png" class="maxwd65">
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c5">
                              5.1. Check in
                          </a>
                      </div>
                      <div id="c5" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture9.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Phần mềm sẽ tự động lấy vị trí check in của user.
                                      </li>
                                      <li> User <b>bắt buộc</b> phải chụp ảnh selfie tại vị trí check in.</li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c6">
                              5.2. Check out
                          </a>
                      </div>
                      <div id="c6" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture10.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle">
                                      <li>Phần mềm sẽ tự động lấy vị trí check out của user.</li>
                                      <li>User bắt buộc phải chụp ảnh selfie tại vị trí check out.</li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c7">
                              5.3. Danh sách lịch sử check in/ check out
                          </a>
                      </div>
                      <div id="c7" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture11.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle">
                                      <li>Danh sách sẽ hiển thị lịch sử các ngày check in/out gần nhất
                                      </li>
                                      <li>Kích chọn ngày sẽ ra trang Chi tiết Check in/ out trong ngày
                                      </li>
                                      <li>Người dùng muốn xem lịch sử lâu hơn => Kích chọn “Xem tất cả”
                                      </li>
                                      <li>Danh sách thể hiện số phút đi muộn/ về sớm tương tự Odoo
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c8">
                              5.4. Chi tiết chấm công
                          </a>
                      </div>
                      <div id="c8" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <p class="magb20">Trên danh sách check in/ out, kích chọn ngày để xem chi tiết check
                                  in/out của ngày đó.
                              </p>
                              <p class="text-center"> <img  src="@/assets/img/hdsd/Picture12.png"></p>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c9">
                              6. Công việc
                          </a>
                      </div>
                      <div id="c9" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <ul class="liststyle magb20">
                                  <li>Có thể thêm công việc/lịch hẹn từ trang chủ => Kích nút “Thêm
                                  </li>
                                  <li>Có thể thêm công việc bằng cách ấn nút “Công việc” trên menu phía dưới màn hình

                                  </li>
                                  <li>Có thể thêm công việc bằng nút điều hướng trên tất cả các trang

                                  </li>
                              </ul>
                              <p class="text-center"> <img  src="@/assets/img/hdsd/Picture13.png"></p>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c10">
                              6.1. Xem danh sách công việc
                          </a>
                      </div>
                      <div id="c10" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture14.png" class="maxwd65">
                                  </p>
                                  <div>
                                      <p>- Có thể xem danh sách công việc theo ngày bằng cách bấm thanh hiển thị theo
                                          ngày <b>(Hình 1)</b>
                                      </p>
                                      <p>- Có thể xem danh sách tất cả công việc bằng cách bấm vào biểu tượng list
                                          trên màn hình <b>(Hình 2)</b>
                                      </p>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c11">
                              6.2. Thêm mới công việc
                          </a>
                      </div>
                      <div id="c11" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture15.png">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Bắt buộc phải nhập : Tiêu đề, thời gian, mục đích công việc
                                      </li>
                                      <li>Có thể thực hiện thêm Merchant ở trang này
                                      </li>
                                      <li>Sau khi nhập đủ thông tin => Kích nút “Lưu lại”
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c12">
                              6.3. Xem chi tiết công việc
                          </a>
                      </div>
                      <div id="c12" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture16.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Công việc mới tạo sẽ có dấu tích màu gray
                                      </li>
                                      <li>Kích chọn vào công việc để xem chi tiết công việc
                                      </li>
                                      <li>Kích chọn “Xem tất cả” ở trang chủ để xem danh sách các công việc theo ngày
                                      </li>
                                      <li>Kích chọn Merchant để xem Merchant
                                      </li>
                                      <li>Kích chọn lịch sử CV để xem công việc đã tạo cho Merchant tương ứng
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c13">
                              6.4. Cập nhật trạng thái công việc
                          </a>
                      </div>
                      <div id="c13" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture17.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>User vào trang chi tiết công việc để cập nhật trạng thái của công việc (Hình
                                          1)
                                      </li>
                                      <li>Nếu công việc chưa hoàn thành
                                          <p>=> Chọn nút “Back” để quay lại trang danh sách (Hình 2)
                                          </p>
                                      </li>
                                  </ul>
                                  
                              </div>
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture18.png" class="maxwd65">
                                  </p>
                                  <div>
                                      <p>3. Nếu công việc đã hoàn thành <br> =><b> Bắt buộc phải cập nhật kết quả công
                                              việc</b>
                                      </p>
                                      <p>*** Đối với công việc phải đi gặp khách hàng => Bắt buộc phải đính kèm ảnh
                                          check
                                          in
                                      </p>
                                      <p>- Kích <b>Lưu lại</b> để cập nhật công việc thành đã hoàn thành
                                      </p>
                                      <p>- Trên thông báo thành công, kích nút<b> Đóng lại</b> để quay về trang danh
                                          sách
                                      </p>
                                  </div>
                              </div>
                              <div>
                                  <p class="magb20">4. Nếu công việc bị HỦY => Bắt buộc phải nhập ghi chú lý do vì sao
                                      hủy</p>
                                  <p class="text-center"> <img  src="@/assets/img/hdsd/Picture19.png"></p>
                              </div>
                              <div>
                                  <div>
                                      <p>Công việc đã hoàn thành sẽ hiển thị thời gian và dấu tích “v” <b>màu xanh</b>
                                      </p>
                                      <p>Công việc bị hủy sẽ hiển thị thời gian và dấu “x” <b>màu đỏ</b>
                                      </p>
                                  </div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture20.png" class="maxwd65">
                                  </p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c14">
                              7. Merchant
                          </a>
                      </div>
                      <div id="c14" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture21.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Có thể thêm Merchant bằng nút điều hướng trên tất cả các trang

                                      </li>
                                      <li>Có thể xem danh sách Merchant bằng cách ấn nút “Merchant” trên menu phía
                                          dưới

                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c15">
                              7.1. Xem danh sách Merchant
                          </a>
                      </div>
                      <div id="c15" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture22.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Có thể xem danh sách Merchant: bao gồm tên, địa chỉ, số điện thoại…
                                      </li>
                                      <li>Có thể xem bản đồ vị trí của Merchant (địa điểm có dấu sao màu cam)
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c16">
                              7.2. Thêm mới Merchant
                          </a>
                      </div>
                      <div id="c16" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture23.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Nhập thông tin thêm mới Merchant (Các trường có dấu * là bắt buộc)

                                      </li>
                                      <li>Kích vào bản đồ để chọn vị trí Merchant
                                          => di chuyển vị trí cho phù hợp
                                      </li>
                                      <li>Có thể thêm Merchant trên trang chi tiết công việc
                                      </li>
                                  </ul>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c17">
                              7.3. Xem chi tiết Merchant
                          </a>
                      </div>
                      <div id="c17" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture24.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Kích chọn để xem chi tiết Merchant trên danh sách hoặc trên bản đồ

                                      </li>
                                      <li>Có thể xem thông tin, vị trí, dịch vụ của Merchant

                                      </li>
                                  </ul>
                              </div>
                              <div>
                                  <p class="magb20">3. Có thể xem và thêm lịch làm việc mới cho Merchant tương ứng đã
                                      chọn</p>
                                  <p> <img  src="@/assets/img/hdsd/Picture25.png"> </p>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="card">
                      <div class="card-header">
                          <a class="card-link collapsed" data-toggle="collapse" href="#c18">
                              7.4. Sửa Merchant
                          </a>
                      </div>
                      <div id="c18" class="collapse" data-parent="#accordion">
                          <div class="card-body">
                              <div>
                                  <p class="text-center">
                                    <img  src="@/assets/img/hdsd/Picture26.png" class="maxwd65">
                                  </p>
                                  <ul class="liststyle magb20">
                                      <li>Kích chọn Sửa Merchant từ trang chi tiết Merchant
                                      </li>
                                      <li>Thực hiện sửa thông tin
                                          => Kích chọn “Cập nhật”

                                      </li>
                                  </ul>
                              </div>

                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>

export default {
  data () {
    return {
      options: {
        defaultWidth: '100%',
        defaultHeight: '100%'
      },
      style: {
        width: '100%'
      }
    }
  },
  methods: {
  },
  components: {
    
  }
}
</script>

<style scoped src="@/assets/css/style_hdsd.css">
</style>

<style scoped src="@/assets/css/bootstrap4.3.1.min.css">
</style>

<style scoped>
.container {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
</style>
